// シールラベル発注・ラベル数管理（kawajun固有）の画面で共有する定義
import store from "@/store/index";
import constant from "@/utils/constant";

// 発注申請のステータス（API の LabelOrderStatus と一致させる）
export const ORDER_STATUS = Object.freeze({
  REQUESTED: 1,            // 依頼済み
  APPROVED: 2,             // 承認済
  APPROVED_WITH_CHANGE: 3, // 修正後承認済み
  CANCELED: 9,             // キャンセル
});

const STATUS_COLOR: Record<number, string> = {
  [ORDER_STATUS.REQUESTED]: "orange-darken-2",
  [ORDER_STATUS.APPROVED]: "green-darken-1",
  [ORDER_STATUS.APPROVED_WITH_CHANGE]: "blue-darken-1",
  [ORDER_STATUS.CANCELED]: "grey",
};

export function statusColor(status: number): string {
  return STATUS_COLOR[status] ?? "grey";
}

// 残数の状態。閾値は画面イメージに合わせる
export const REMAIN_LOW = 500;
export const REMAIN_WARN = 1500;

export function remainState(remaining: number): "low" | "warn" | "ok" {
  if (remaining < REMAIN_LOW) return "low";
  if (remaining < REMAIN_WARN) return "warn";
  return "ok";
}

const REMAIN_COLOR = { low: "red-darken-1", warn: "amber-darken-3", ok: "green-darken-1" };

export function remainColor(remaining: number): string {
  return REMAIN_COLOR[remainState(remaining)];
}

// 増減履歴の種別
export const LEDGER_KIND_COLOR: Record<string, string> = {
  DELIVERY: "blue-darken-1",
  SHIPMENT: "red-darken-1",
  ADJUSTMENT: "amber-darken-3",
  PLANNED: "grey",
};

// 数値の表示（3桁区切り）
export function num(v: number | null | undefined): string {
  return Number(v ?? 0).toLocaleString("ja-JP");
}

// 符号付きの数値（+1,000 / -3 / ±0）
export function signed(v: number): string {
  if (v === 0) return "±0";
  return (v > 0 ? "+" : "") + num(v);
}

// 承認・修正して承認・キャンセルができるか（管理者のみ）
export function isAdmin(): boolean {
  return store.getRole() === constant.ROLE.ADMIN.id;
}

// 画面遷移後に1度だけ表示する完了メッセージ
const FLASH_KEY = "labelManagementFlash";

export function setFlash(message: string): void {
  sessionStorage.setItem(FLASH_KEY, message);
}

export function popFlash(): string {
  const message = sessionStorage.getItem(FLASH_KEY) ?? "";
  sessionStorage.removeItem(FLASH_KEY);
  return message;
}
